import React, {useContext, useEffect, useRef, useState} from 'react';
import { IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonText, IonModal } from '@ionic/react';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context'

import '../../css/layout.css';

import { Preferences } from '@capacitor/preferences'

function addStorage_cart(event) {

    //alert(event);

    Preferences.set({
        key: 'cartList',
        value: JSON.stringify(event),
        //value: [event[0], event[1], event[2], event[3],  event[4]].toString(),

    })
}

export function Helpdesk_Internal (props) {


    let zasava_context = useContext(Auth_Zasava_Context);

    let [acctID, setAccountID ] = useState(zasava_context.acctID);
    let [employeeID, setEmployeeID ] = useState(zasava_context.employeeID);
    let [schema, setSchema ] = useState(zasava_context.schema);
    let [access, setAccessRights ] = useState(zasava_context.accessRights);
    let [sessionID, setSessionID ] = useState(zasava_context.sessionID);
    let [baseURL, setBaseURL ] = useState(zasava_context.baseURL);
    let [wss, setWebsocket ] = useState(zasava_context.websocket);

  const [viewCustomers, setCustomers] = useState([]);
  const [showCustomerMessage, setShowCustomerMessage] = useState([]);


  const [clients, setClients] = useState({});

  let [chatID, setChatID] = useState(null);

  let [messageSent, setMessageSent] = useState(false);
  let [viewMessages, setMessages] = useState([]);
  let [inputMessage, setInputMessage] = useState('');


  function getMessages() {

    setClients({});

    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74706_helpDesk_internal_getMessages',
            user: acctID,
            sessionID: sessionID,
        }),
    }

    //alert(props.data.companyId);
    //alert(props.data.productID);

    
    fetch(baseURL+'zsava_internal_indexApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');


        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {
            let cols = rows[rownum].split('|');

            setCustomers((prevViewCustomers) => {
                return prevViewCustomers.concat({
                    id: cols[0],
                    customerName: cols[1],

                })
            });

            const chainLength = Object.keys(JSON.parse(cols[3])).length;

            for (let colRow = 1; colRow <= chainLength; ++colRow)
            {
                let colsParsed = JSON.parse(cols[3])[colRow];

                setMessages((prevViewMessages) => {
                    return prevViewMessages.concat({
                        id: cols[0],
                        text: colsParsed.text,
                        sender: colsParsed.sender,

                    })
                });

            }
        }
        
    })

}



function sendMessage()
{  

        alert('677777777');
        alert(JSON.stringify(clients));

          const requestOptions = {
            method: 'POST',
            //mode: 'no-cors',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74706_helpDesk_internal_sendMessages',
                user: acctID,
                xChatID: chatID,
                xHelp_chat_message: JSON.stringify(clients),
                sessionID: sessionID,

            }),
        }


        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {
            
              getMessages();

      })
        

}


function sendMessageHandler()
{


      let updatedClientList = {};
      // alert(cartItems);
      // alert(JSON.stringify(cartItems));

      // alert(cartList);

      setClients((prevClientList) => {

          let nextID = Object.keys(prevClientList).length + 1;
           alert("in setclient");
           alert(nextID);
           alert(JSON.stringify(prevClientList));

          let clientItems = {
              id: nextID,
              text: inputMessage,
              sender: acctID,
              };

              alert(clientItems);

          updatedClientList = {
              ...prevClientList,  // Preserve existing properties
              [nextID]: clientItems // Add new client item using `acctID` as the key
          };

          // Store the updated list in local storage
          addStorage_cart(updatedClientList);

          setMessageSent(true)

          return updatedClientList; // Update state
      });


      zasava_context.changeCartList((prevClientList) => {

          let nextID = Object.keys(prevClientList).length + 1;

           alert("in changecartlist");
           alert(nextID);
           alert(JSON.stringify(prevClientList));

          let clientItems = {
              id: nextID,
              text: inputMessage,
              sender: acctID,
              };

          return {
              ...prevClientList,
              [nextID]: clientItems // Add new client item using `acctID` as the key
          };
      });

}

function handleShowCustomerMessage(event)
{
    setChatID(event[0]);
    setShowCustomerMessage(event[0]);
}


useEffect(() => {

    //alert("In Websocket Use Event");
    
    wss.onopen = () => {
        alert('WebSocket opened');
      };

    wss.onmessage = (event) => {

      alert("WebSocket message recieved");
      alert(data.type );

      const data = JSON.parse(event.data);

      if (data.type === 'CHAT_UPDATED') 
      {
        getMessages();
      }
    };

    return () => wss.close(); // Cleanup WebSocket connection

  }, []);



useEffect(() => {
  if (messageSent) {
      sendMessage();
      setMessageSent(false); // Reset flag to prevent repeated calls
  }
}, [messageSent]);


useEffect(() =>  {

    getMessages(); 

}, [])

  return (
    <React.Fragment>

          {/* Chat Modal */}
          {props.openModal == true ?
            (
            <IonModal isOpen={props.openModal}>
            <IonHeader style={{ color: "black" }}>
                <IonGrid>
                    <IonRow>
                        <IonCol size='9'>
                            <h4>HELP DESK</h4>
                        </IonCol>
                        <IonCol size='3'>
                            <IonButton onClick={() => props.closeModal()}> Close </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>

            <IonContent className='grid_content'>
                <IonGrid>
                    <IonRow >
                        {viewCustomers.map((detailData) =>   {
                            return (
                                    <IonCol>
                                        <IonButton onClick={() => handleShowCustomerMessage([detailData.id])}>{detailData.id} - {detailData.customerName} </IonButton>
                                    </IonCol>
                                    )
                                }
                            )}
                        </IonRow>
                    </IonGrid>
                    <IonGrid>
                        {viewMessages.map((detailData) =>   {
                            return ( showCustomerMessage == detailData.id &&
                                        <IonRow className="ion-justify-content-end">
                                            <IonCol size='6'>
                                                <IonText >{detailData.text} </IonText>
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                            )}
                     </IonGrid>
                </IonContent>

            <IonFooter className='grid_footer'>
                <IonGrid style={{ color: "black" }}>
                    <IonRow>
                        <IonCol size="9">
                            <IonInput type='text' placeholder="Type a message..." value={inputMessage }  autocomplete='off' onIonChange={(e) => setInputMessage(e.target.value)} ></IonInput>
                        </IonCol>
                        <IonCol size='3'>
                            <IonButton onClick={() => sendMessageHandler()}>Send</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
          </IonModal>
        ): null }


    </React.Fragment>
  );
};

export default Helpdesk_Internal;